import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanningProfileList extends Layout {
    labelSearchManifestConfigurationProfiles: Label;
    sourceManifestProfile: DataSource;
    tableManifestProfile: Table;
}
